/* Page-owned navigation and gallery. Shared product form owns cart/checkout. */
(function () {
  'use strict';
  function init() {
    var root = document.querySelector('.dms2');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Animate only the decoration: evidence labels and final heights are rendered by Liquid. */
    var chart = root.querySelector('[data-dms2-chart]');
    if (chart && !reduced && 'IntersectionObserver' in window && typeof Element.prototype.animate === 'function') {
      var chartObserver = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        chartObserver.disconnect();
        chart.querySelectorAll('.dms2-bar').forEach(function (bar, n) {
          bar.animate([{transform: 'scaleY(0)'}, {transform: 'scaleY(1)'}], {
            duration: 800, delay: n * 120, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards'
          });
        });
      }, {threshold: 0.4});
      chartObserver.observe(chart);
    }
    function track(name, payload) {
      if (typeof window.fireEvent === 'function') {
        try { window.fireEvent(name, payload || {}); } catch (err) { /* Analytics must not block navigation. */ }
      }
    }
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-scroll-to]');
      if (!link) return;
      var target = document.getElementById(link.getAttribute('data-scroll-to'));
      if (!target) return;
      e.preventDefault();
      target.focus({preventScroll: true});
      window.scrollTo({top: target.getBoundingClientRect().top + window.pageYOffset - 24, behavior: reduced ? 'auto' : 'smooth'});
      track('lp_meno_sleep_v2_cta_click', {label: link.textContent.trim(), cta: link.getAttribute('data-scroll-to')});
    });
    var images = Array.from(root.querySelectorAll('.lp-product__primary-img'));
    var thumbs = Array.from(root.querySelectorAll('.lp-product__thumb'));
    var active = 0;
    function select(index, focus) {
      if (index < 0 || index >= images.length) return;
      active = index;
      images.forEach(function (img, n) { img.dataset.active = n === index ? 'true' : 'false'; });
      thumbs.forEach(function (thumb, n) {
        thumb.classList.toggle('lp-product__thumb--active', n === index);
        thumb.setAttribute('aria-selected', n === index ? 'true' : 'false');
        thumb.tabIndex = n === index ? 0 : -1;
      });
      if (thumbs[index]) {
        if (focus) thumbs[index].focus();
        thumbs[index].scrollIntoView({block: 'nearest', inline: 'nearest', behavior: reduced ? 'auto' : 'smooth'});
      }
    }
    thumbs.forEach(function (thumb, n) {
      thumb.tabIndex = n === 0 ? 0 : -1;
      thumb.addEventListener('click', function () { select(n, false); });
      thumb.addEventListener('keydown', function (e) {
        var next = n;
        if (e.key === 'ArrowRight') next = (n + 1) % images.length;
        else if (e.key === 'ArrowLeft') next = (n + images.length - 1) % images.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = images.length - 1;
        else return;
        e.preventDefault(); select(next, true);
      });
    });
    var primary = root.querySelector('.lp-product__primary');
    var start;
    if (primary) {
      primary.addEventListener('pointerdown', function (e) { if (e.button === 0) start = {x:e.clientX,y:e.clientY}; });
      primary.addEventListener('pointerup', function (e) {
        if (!start) return;
        var dx=e.clientX-start.x, dy=e.clientY-start.y; start=null;
        if (Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)) select((active + (dx<0 ? 1 : images.length-1)) % images.length, false);
      });
      primary.addEventListener('pointercancel', function () { start=null; });
      primary.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
    track('lp_meno_sleep_v2_view', {product_handle: 'menopause-essentials'});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
